import { clamp } from './math-utils'

export class Range {
  static getInfinityRange(): Range {
    return new Range(-Infinity, Infinity);
  }

  private min;
  private max;

  constructor(min: number, max: number) {
    this.min = Math.min(min, max);
    this.max = Math.max(min, max);
  }

  public clamp(value: number): number {
    return clamp(value, this.min, this.max);
  }

  public isAbove(value: number): boolean {
    return value > this.max;
  }

  public isBelow(value: number): boolean {
    return value < this.min;
  }
}